const constant = {
  checklist: [
    "Conversion",
    "Conversion Series 6 to 7",
    "Izenda-SMB",
    "Maintenance Izenda New",
    "Maintenance Renewal",
    "Subscription - Current",
    "Subscription - Current Series 7",
    "Subscription Renewal",
    "Subscription Renewal 7 Series",
  ],
   inclusionArray : [
     '/',
     'request-access',
    '/invoice',
    '/license',
    '/download',
    '/member',
    '/profile',
  ],
  passwordStatus: [
    {
        type: "length",
        error: false,
        regex: "",
        Msg: "Password must contain between 8 and 20 characters",
    },
    {
        type: "character",
        error: false,
        regex: /^(?=.*[a-z])(?=.*[A-Z])/,
        Msg: "Password must contain upper and lowercase letters",
    },
    {
        type: "special",
        error: false,
        regex: /^(?=.*[!@#$%^&*])/,
        Msg: "Password must contain at least one special character",
    },
    {
        type: "number",
        error: false,
        regex: /^(?=.*[0-9])/,
        Msg: "Password must contain at least one number",
    },

],
};
export default constant;



// WEBPACK FOOTER //
// ./src/common/constant.js